import './Page1089Style.css';

function Page1089Success() {
  return (
    <div className="Aa3">
      <div className='container'>
        <div className='header'>
          <div className='header-right'>
            <div className='logo'><img alt='Kid Security' src='./../../kid-security-logo.png' /></div>
          </div>
        </div>
        <div className='form-content'>
          <div className='title'>
            <h4 id='headup-title'>{'Легко и безопасно'}</h4>
          </div>
          <div className='form-content-top'>
            <div className='logo'><img alt='Kid Security' src='./../../phone-icon.png' /></div>
          </div>
          <div className='form-content-middle'>
            <div className='title'>
              <h3 id='title'>{'Операция прошла успешно'}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page1089Success;